import { render, staticRenderFns } from "./BulkLearnerReportsComponent.vue?vue&type=template&id=3a34b5b8"
import script from "./BulkLearnerReportsComponent.vue?vue&type=script&lang=js"
export * from "./BulkLearnerReportsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports